export default {
    title: "Pomza Export",
    description: {
        tr: "Pomza Export A.Ş., madencilik sektöründe tamamen yerli sermaye kurulmuş, köklü bir şirket olarak 50 yıldan fazla süredir faaliyet göstermektedir.",
        en: "Pomza Export is one of the leading companies shaping Turkey's mining sector since 1961.",
    },
    headerTitle: "Pomza Export",
    theme: "system",
    siteUrl: "https://www.pomzaexport.com/",
    siteLogo: "https://www.pomzaexport.com/assets/logo/pomza.png",
    socialBanner: "https://www.pomzaexport.com/assets/logo/pomza.png",
    email: "info@pomzaexport.com",
    linkedin: "https://www.linkedin.com/company/pomzaexport/",
    instagram: "https://www.instagram.com/pomza.exportt",
    facebokk: "https://www.facebook.com/61565487748657",
    keywords: {
        tr: [
            "Türkiye'de altın üreten ilk yerli firma",
            "Türkiye'nin ilk ve tek Rutil üreticisiyiz",
            "Ülkenin ilk ve tek Garnet üreticisiyiz",
            "maden",
            "altın madeni",
            "altın",
            "kuvars",
            "rutil",
            "agrega",
            "garnet",
            "silis kumu",
            "hematit",
            "perlit",
            "pomza",
            "korund",
            "hazır beton",
        ],
        en: [
            "first local company to produce gold in Turkey",
            "Turkey's first and only Rutile producer",
            "Turkey's first and only Garnet producer",
            "mining",
            "gold mining",
            "gold",
            "kuvars",
            "aggregates",
            "garnet",
            "silica sand",
            "hematite",
            "perlite",
            "pumice",
            "emery",
            "ready mixed concrete",
        ],
    },
    productsPage: {
        title: {
            tr: "Ürünler",
            en: "Products",
        },
        description: {
            tr: "Pomza, perlit, kuvars ve diğer endüstriyel minerallerin özellikleri, kullanım alanları ve Pomza Export ürün grupları hakkında bilgi edinin.",
            en: "Learn about pumice, perlite, quartz and other industrial minerals, their properties, applications and Pomza Export product groups.",
        },
        keywords: { tr: [], en: [] },
    },
    aboutPage: {
        title: {
            tr: "Hakkımızda",
            en: "About Us",
        },
        description: {
            tr: "Pomza Export’un madencilik faaliyetleri, kurumsal yaklaşımı, çevre ve kalite politikaları hakkında bilgi edinin.",
            en: "Discover Pomza Export’s mining activities, company background, environmental approach and quality policies.",
        },
        keywords: {
            tr: [
                "Sart Maden İşletmesi",
                "Yeniköy Maden İşletmesi",
                "Küner Maden İşletmesi",
            ],
            en: [
                "Sart Mining Facility",
                "Yeniköy Mining Facility",
                "Küner Mining Facility",
            ],
        },
    },
    contactPage: {
        title: {
            tr: "İletişim",
            en: "Contact",
        },
        description: {
            tr: "Pomza Export’un Manisa, İzmir ve Ankara adreslerine, işletme telefonlarına ve iletişim bilgilerine ulaşın.",
            en: "Find addresses, facility telephone numbers and contact details for Pomza Export in Manisa, İzmir and Ankara.",
        },
        keywords: {
            tr: [
                "Sart Maden İşletmesi",
                "Yeniköy Maden İşletmesi",
                "Küner Maden İşletmesi",
            ],
            en: [
                "Sart Mining Facility",
                "Yeniköy Mining Facility",
                "Küner Mining Facility",
            ],
        },
    },
    minePage: {
        title: {
            tr: "Maden İşletmelerimiz",
            en: "Mining Facilities",
        },
        description: {
            tr: "Manisa ve İzmir’deki Sart, Yeniköy ve Küner maden işletmelerini, faaliyetlerini ve ürün gruplarını keşfedin.",
            en: "Explore Pomza Export’s Sart, Yeniköy and Küner mining facilities in Manisa and İzmir, their activities and mineral products.",
        },
        keywords: {
            tr: [
                "Sart Maden İşletmesi",
                "Yeniköy Maden İşletmesi",
                "Küner Maden İşletmesi",
            ],
            en: [
                "Sart Mining Facility",
                "Yeniköy Mining Facility",
                "Küner Mining Facility",
            ],
        },
    },
};
